import { getCurrentLanguage } from 'utils/src/getCurrentLanguage';
import { apiClient } from '../../../../apps/crossword-maker/src/shared/apiClient';
import { ICrosswordBookWordCategoryWithWord } from './CrosswordBook.api.types';

export interface IReplaceCategoryDataType {
	oldCategoryId: string;
	newCategoryValue: string;
	wordsIds: string[];
}

export const replaceCrosswordBookCategories = async (data: IReplaceCategoryDataType): Promise<ICrosswordBookWordCategoryWithWord[]> => {
	const language = getCurrentLanguage();

	const response = await apiClient().post<ICrosswordBookWordCategoryWithWord[]>(
		`/rest/${language}/crossword-book/word-categories/replace`,
		data
	);

	return response.data;
};
